import React, { useMemo } from 'react'
import { Autocomplete, Divider, Grid, ListItemIcon, ListItemText, TableCell, TableRow, TextField, Typography } from '@mui/material';
import { useContext } from 'react';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconsColor from '../../../../../utility/iconsColor';
import { functionParameters, functionResponse } from './customAPIConfigPopup';
import { customVariableDataInterface, functionParameterData, functionResponseData } from '../../../../../../models/axiosModel';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { primaryColor } from '../../../../../../utils/colors';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { getVariableLabelName, getVariableOptionsBasedOnVariableType, getVariableTypeValue, getVariableValue } from '../../../flowBuilderConstants';
import { filterAutocompleteOptionsWithException } from '../../../../../../utils/constants';

type TableParameter = functionParameterData | functionResponseData;

const isFunctionParameterRow = (parameter: TableParameter) => "function_parameter_name" in parameter;

const getParameterDataIdFromRow = (parameter: TableParameter) => isFunctionParameterRow(parameter) ? parameter.function_parameter_data_id : parameter.function_response_data_id;

const getPayloadEntryByParameter = (payload: any, parameter: any) => {
    const parameterDataId = getParameterDataIdFromRow(parameter);
    const isFunctionParameter = isFunctionParameterRow(parameter);
    return payload?.find((entry: any) =>
        (isFunctionParameter
            ? (entry as functionParameters).function_parameter_data_id
            : (entry as functionResponse).function_response_data_id) == parameterDataId,
    ) ?? null;
};

const MemoizedRow = React.memo((props: any) => {
    const { payload, ind, parameter, onChangeOfField, onChangeOfFallbackValue,
        setFlagEditResVarPathPopup, setSelectedResPayload, onChangeOfFieldVariableTypeForFunctionParameter
    } = props
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const setExistingCustomVariablePayload = useFlowBuilderStore((state) => state.setExistingCustomVariablePayload)


    const { variableTypes } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const metaDataVariableList = useFlowBuilderStore((state) => state.metaDataVariableList)

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const isFunctionParameter = isFunctionParameterRow(parameter as TableParameter);

    const parameterDataId = useMemo(
        () => getParameterDataIdFromRow(parameter as TableParameter),
        [parameter],
    );

    const parameterData = useMemo(
        () => getPayloadEntryByParameter(payload, parameter as TableParameter),
        [payload, parameter],
    );

    const handleEditFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setFlagDataCollectionPopup(true);
        setFlagUpdateFieldData(true);
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
    }

    const handleDeleteFieldData = (event: any, option: customVariableDataInterface) => {
        event.stopPropagation();
        setExistingCustomVariablePayload({
            ...existingCustomVariablePayload,
            chatbot_custom_variable_config_id: option.chatbot_custom_variable_configuration_id,
            chatbot_custom_variable_name: option.chatbot_custom_variable_name,
            chatbot_custom_variable_fallback_value: option.chatbot_custom_variable_fallback_value
        })
        if (setFlagDeleteData) {
            setFlagDeleteData(true)
        }
    }


    const renderOptions = (props: React.HTMLAttributes<HTMLLIElement>, option: any): React.ReactNode => {
        if (option.chatbot_custom_variable_configuration_id == "-1" && option.chatbot_custom_variable_name == "New Field") {
            return (
                <ul className={contactStyles.newTagNameUlElement}>
                    <Divider className={contactStyles.newTagDivider} />
                    <li {...props} style={{ minHeight: "auto", cursor: "pointer", padding: "10px 16px", display: "flex", alignItems: "center", gap: "5px", boxSizing: "border-box", outline: "none", color: primaryColor }} onClick={() => { setFlagDataCollectionPopup(true); }}>
                        <AddIcon />
                        <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>New Field</Typography>
                    </li>
                </ul>
            )
        }
        return (
            <li {...props} key={option.chatbot_custom_variable_configuration_id}>
                <Grid container className={globalStyles.wordBreakBreakAll}>
                    <ListItemText primary={option.chatbot_custom_variable_name} className={styles.listItemsStyle} />
                </Grid>
                <Grid container justifyContent={"end"} sx={{ maxWidth: "60px" }}>
                    <Grid item onClick={(e) => e.stopPropagation()}>
                        <ListItemIcon onClick={(event) => handleEditFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}>
                            <EditIcon sx={{ height: "14px", width: "14px", fontSize: "14px" }} />
                        </ListItemIcon>
                    </Grid>
                    <Grid item onClick={(e) => e.stopPropagation()} paddingLeft={"12px"}>
                        <ListItemIcon onClick={(event) => handleDeleteFieldData(event, option)} sx={{ padding: "0", minWidth: "10px !important" }}
                        >
                            <IconsColor height="14" width="14" iconName="DeleteIcon" fillColor="#7A7A7A" />
                        </ListItemIcon>
                    </Grid>
                </Grid>
            </li>
        )
    }

    function getRenderOptions() {
        let variableType = parameterData?.variable_type?.variable_type_name
        switch (variableType?.toLowerCase()) {
            case 'metadata':
                return undefined
            default:
                return renderOptions
        }
    }

    const checkIfPathChanged = (path: string) => {
        if (path) {
            const bracketMatches = path.match(/\[([^\]]+)\]/g);
            if (bracketMatches) {
                return bracketMatches.some(item => /^\["?\d+"?\]$/.test(item));
            }
            return false;
        } else {
            return false;
        }
    }
    function getListBoxProps() {
        let variableType = parameterData?.variable_type?.variable_type_name
        switch (variableType?.toLowerCase()) {
            case 'metadata':
                return undefined
            default:
                return { style: { maxHeight: '150px', overflow: 'auto', paddingBottom: "50px" } }
        }
    }

    const responsePayloadEntry = !isFunctionParameter ? (parameterData as functionResponse | null) : null;

    return <>
        <TableRow key={ind} className={whatsAppCampaignStyles.tableRow}>
            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                <Grid container className={globalStyles.flexColumn} gap={"3px"}>
                    <Grid item> {isFunctionParameter ? parameter.function_parameter_name : parameter.function_response_name} </Grid>
                    <Grid item className={styles.responseVariablePathText} sx={{ color: "#4C4A4D" }}>
                        Type: {`${parameter.function_parameter_type_name.charAt(0).toUpperCase()}${parameter.function_parameter_type_name.slice(1)}`}
                    </Grid>
                    {!isFunctionParameter &&
                        <Grid item>
                            <Grid container gap={"3px"} className={styles.responseVarEditPathContainer}>
                                <Grid item className={styles.responseVariablePathText} sx={{ color: checkIfPathChanged(responsePayloadEntry?.action_custom_api_call_response_variable_path ?? "") ? "#2d2828" : "#4C4A4D" }}>
                                    Path: {responsePayloadEntry?.action_custom_api_call_response_variable_path}
                                </Grid>
                                {parameter.insideArray &&
                                    <Grid
                                        item
                                        className={`${globalStyles.displayFlexStyle} ${styles.responseVariablePathEditIconGrid}`}
                                        onClick={() => {
                                            setFlagEditResVarPathPopup(true);
                                            if (responsePayloadEntry) {
                                                setSelectedResPayload(responsePayloadEntry);
                                            }
                                        }}>
                                        <EditIcon className={styles.responseVariablePathEditIcon} />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </TableCell>
            {isFunctionParameter &&
                <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle} sx={{ minWidth: "150px" }}>
                    <Autocomplete
                        key={parameterDataId}
                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                        className={`${contactStyles.contactFilterDropdownsInPopup} ${globalStyles.fullwidth}`}
                        options={variableTypes}
                        getOptionLabel={(option) => option.variable_label || ''}
                        value={getVariableTypeValue(variableTypes, parameterData?.variable_type?.variable_type_name)}
                        sx={{ '&:hover': { backgroundColor: "white !important" }, backgroundColor: "white !important" }}
                        onChange={(_: React.SyntheticEvent, value: customVariableDataInterface | null) => {
                            onChangeOfFieldVariableTypeForFunctionParameter(value, parameterDataId);
                        }}
                        renderInput={(params) => <TextField {...params} placeholder="Select Field Type" />}
                    />
                </TableCell>}
            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle} sx={{ minWidth: "150px" }}>
                <Autocomplete
                    key={parameterDataId}
                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                    className={`${contactStyles.contactFilterDropdownsInPopup} ${globalStyles.fullwidth}`}
                    options={getVariableOptionsBasedOnVariableType(customVariableList, metaDataVariableList, parameterData?.variable_type?.variable_type_name, currentActiveStaticWorkflow) || []}
                    getOptionLabel={(option: any) => option[getVariableLabelName(parameterData?.variable_type?.variable_type_name)] || ''}
                    filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, getVariableLabelName(parameterData?.variable_type?.variable_type_name), "chatbot_custom_variable_configuration_id")}
                    value={getVariableValue(customVariableList, metaDataVariableList, currentActiveStaticWorkflow, parameterData?.variable_type?.variable_type_name || null, parameterData?.chatbot_custom_variable_configuration_id || null, parameterData?.metadata_type?.metadata_type_id || null)}
                    sx={{ '&:hover': { backgroundColor: "white !important" }, backgroundColor: "white !important" }}
                    onChange={(_: React.SyntheticEvent, value: customVariableDataInterface | null) => {
                        onChangeOfField(value, parameterDataId);
                    }}
                    ListboxProps={getListBoxProps()}
                    renderOption={getRenderOptions()}
                    renderInput={params => {
                        const { InputProps, ...restParams } = params;
                        const { startAdornment, ...restInputProps } = InputProps;
                        return (
                            <TextField
                                {...restParams}
                                placeholder='Select Field'
                                InputProps={{
                                    ...restInputProps,
                                    startAdornment: (
                                        <div style={{
                                            maxHeight: "90px",
                                            overflowY: 'auto',
                                        }}
                                        >
                                            {startAdornment}
                                        </div>
                                    ),
                                }}
                            />
                        );
                    }}
                />
            </TableCell>
            <TableCell className={whatsAppCampaignStyles.tableSubHeadingFontStyle}>
                <TextField
                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                    value={isFunctionParameter
                        ? (parameterData as functionParameters | null)?.function_parameter_fallback_value || ""
                        : (parameterData as functionResponse | null)?.function_response_fallback_value || ""}
                    placeholder='Enter Fallback Value'
                    onChange={(e) => {
                        onChangeOfFallbackValue(e.target.value, parameterDataId);
                    }}
                    className={whatsAppCampaignStyles.whatsappCampaignTextField}
                    sx={{ width: "100%", backgroundColor: "white" }}
                />
            </TableCell>
        </TableRow>
    </>
}, areEqualMemoizedRow)

function areEqualMemoizedRow(prevProps: any, nextProps: any) {
    const sameParameter = JSON.stringify(prevProps.parameter) === JSON.stringify(nextProps.parameter);
    const prevPayloadEntry = getPayloadEntryByParameter(prevProps.payload, prevProps.parameter);
    const nextPayloadEntry = getPayloadEntryByParameter(nextProps.payload, nextProps.parameter);
    const samePayloadEntry = JSON.stringify(prevPayloadEntry) === JSON.stringify(nextPayloadEntry);

    return sameParameter && samePayloadEntry;
}

export default MemoizedRow
